import { Row, Col, Image, Card, Typography, Button } from 'antd';
import logo from '../../assets/btm logo.png';
import { img, row, portalButton } from './style';

const CanIDeleteMyAccount = () => (
  <Row justify="end" align="middle" style={{ flexDirection: 'column' }}>
    <Col>
      <Image style={img} src={logo} width={350} preview={false} />
    </Col>
    <Col xs={22} lg={16} xl={12}>
      <Card
        headStyle={{ textAlign: 'center' }}
        title="Μπορώ να διαγράψω το λογαριασμό μου;"
      >
        <Typography.Text>
          Μπορείς να διαγράψεις το λογαριασμό σου οποιαδήποτε στιγμή το
          επιθυμείς με έναν από τους παρακάτω τρόπους:
        </Typography.Text>
        <Row style={row}>
          <ul>
            <Col>
              <li>
                είτε μέσω της εφαρμογής Short Drive μέσω του μενού &quot;Ο
                Λογαριασμός μου&quot; επιλέγοντας &quot;Διαγραφή
                Λογαριασμού&quot;.
              </li>
            </Col>
            <Col>
              <li>
                είτε μέσω του
                <Button
                  type="link"
                  style={portalButton}
                  onClick={() => {
                    window.open('https://www.myshortdrive.gr');
                  }}
                >
                  portal
                </Button>
                επιλέγοντας &quot;Διαγραφή Λογαριασμού&quot;.
              </li>
            </Col>
            <Col>
              <li>
                είτε στέλνοντας μας email στο
                <Typography.Text strong>
                  &nbsp;appdatadeletion@anytime.gr
                </Typography.Text>
                <Typography.Text>
                  &nbsp;δηλώνοντας την επιθυμία σου για τη διαγραφή δεδομένων
                  της εφαρμογής και τον Αρ. Συμβολαίου σου.
                </Typography.Text>
              </li>
            </Col>
          </ul>
        </Row>
        <Row style={row}>
          <Typography.Text>
            Για να ολοκληρωθεί η διαδικασία διαγραφής θα πρέπει να γίνει και
            απεγκαταταση (uninstall) της εφαρμογής.
          </Typography.Text>
        </Row>
        <Row style={{ display: 'inline' }}>
          <Typography.Text>
            Βεβαιώσου ότι έχεις ελέγξει τυχόν σημαντικές πληροφορίες ή δεδομένα
            που σχετίζονται με τον λογαριασμό σου πριν τη διαγραφή αυτού, καθώς
            είναι μη ανακτήσιμα μετά την ολοκλήρωση της διαδικασίας.
          </Typography.Text>
          <Typography.Text strong>
            &nbsp;Διευκρινίζεται ότι μετά τη διαγραφή, η ανανέωση του συμβολαίου
            σου δε θα πραγματοποιείται αυτόματα και θα χρειαστεί να γίνει έκδοση
            σε νέο short drive πρόγραμμα.
          </Typography.Text>
        </Row>
      </Card>
    </Col>
  </Row>
);

export default CanIDeleteMyAccount;
